import { render, staticRenderFns } from "./CreateCertificate.vue?vue&type=template&id=e637afaa"
import script from "./CreateCertificate.vue?vue&type=script&lang=js"
export * from "./CreateCertificate.vue?vue&type=script&lang=js"
import style0 from "./CreateCertificate.vue?vue&type=style&index=0&id=e637afaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports